import { CuisineCategories, CuisineTypes, RestaurantTypes } from '../../../../../modals/company/Constants';
import { Step } from '../../../../../modals/company/add-company-modal';
import { LeadSources, PosSystems } from '../../../../../modals/company/add-company-modal/BusinessDetails';
import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Inscription du restaurant',
  description: 'Étape {{activeStep}} sur {{totalSteps}}',
  steps: {
    [Step.BasicInfo]: 'Infos de base',
    [Step.BusinessDetails]: "Détails de l'établissement",
  },
  form: {
    name: {
      label: 'Nom du restaurant',
      placeholder: 'Saisir le nom du restaurant',
    },
    timezone: {
      label: 'Fuseau horaire',
      placeholder: 'Rechercher une ville ou un fuseau horaire',
      inference_failed:
        "Nous n'avons pas pu déterminer le fuseau horaire à partir de cette adresse — veuillez le sélectionner.",
    },
    google_place: {
      label: 'Lieu Google sélectionné : {{name}}',
    },
    is_franchise: {
      label: "Le restaurant fait partie d'une marque",
    },
    sync_lieferando_brand: {
      label: 'Récupérer les détails de la marque (logo, couleur principale) depuis Lieferando',
    },
    import_menu: {
      label: 'Importer le menu',
    },
    lieferando_url: {
      label: 'URL Lieferando',
      placeholder: 'URL du restaurant sur Lieferando',
    },
    other_platforms: {
      label: 'Plateformes de livraison actuelles',
      description: 'Sélectionnez les plateformes où vous êtes référencé',
    },
    pos_system: {
      label: 'Système de caisse actuel',
      placeholder: 'Sélectionnez votre système de caisse',
      options: {
        [PosSystems.Other]: 'Autre',
      },
    },
    delivery_mode: {
      label: 'Mode de livraison',
      placeholder: 'Sélectionnez le mode de livraison',
      options: {
        [DeliveryMode.Internal]: 'Interne (propres livreurs)',
        [DeliveryMode.External]: 'Externe (sous-traitant)',
      },
    },
    monthly_sales_other_platforms: {
      label: 'Ventes livraison mensuelles',
      description: 'Ventes totales sur toutes les plateformes de livraison',
      placeholder: 'Sélectionnez une plage de ventes',
      options: {
        other: 'Autre',
      },
      other: {
        placeholder: 'Saisir le montant des ventes',
      },
    },
    lead_source: {
      label: 'Source du prospect',
      description: 'Comment nous avez-vous connus ?',
      options: {
        [LeadSources.SDR]: {
          title: 'SDR',
          description: 'Démarchage par un SDR',
        },
        [LeadSources.Inbound]: {
          title: 'Entrant',
          description: 'Venu via le site web ou le marketing',
        },
        [LeadSources.Referral]: {
          title: 'Parrainage – Restaurant existant',
          description: 'Recommandé par un restaurant partenaire',
        },
        [LeadSources.SelfGeneratedCold]: {
          title: 'Autogénéré – Prospection à froid',
          description: 'Trouvé via prospection à froid',
        },
        [LeadSources.SelfGeneratedReferral]: {
          title: 'Autogénéré – Parrainage',
          description: 'Réseau personnel ou relation',
        },
        [LeadSources.Tipster]: {
          title: "Apporteur d'affaires",
          description: 'Foodamigos verse une commission à la personne/société X pour la recommandation',
        },
      },
    },
    sdr: {
      description: 'Sélectionnez le SDR responsable de ce prospect',
    },
    has_instagram_profile: {
      label: 'Profil Instagram',
      description: 'Votre restaurant a-t-il un profil Instagram ?',
      options: {
        true: 'Oui',
        false: 'Non',
      },
    },
  },
  buttons: {
    back: 'Retour',
    next: 'Suivant',
    complete_registration: "Finaliser l'inscription",
  },
  basic_information: {
    title: 'Informations de base',
    description: 'Saisir les coordonnées et informations de base du restaurant',
  },
  additional_options: {
    title: 'Options supplémentaires',
    description: 'Configurer les paramètres supplémentaires de ce restaurant',
  },
  restaurant_type: {
    title: 'Type de restaurant & modèle de service',
    description: 'Choisissez le format qui décrit le mieux ce restaurant',
  },
  cuisine_type: {
    title: 'Catégories alimentaires & types de cuisine',
    description: 'Sélectionnez toutes les catégories et types de cuisine applicables',
    placeholder: 'Rechercher des types de cuisine',
  },
  business_details: {
    title: "Détails de l'établissement",
    description: 'Aidez-nous à comprendre vos activités actuelles',
  },
  restaurant_types: {
    [RestaurantTypes.FullServiceRestaurant]: {
      title: 'Restaurant avec service complet',
      description: 'Restauration à table avec service en salle',
    },
    [RestaurantTypes.FastCasual]: {
      title: 'Fast Casual',
      description:
        'Commande au comptoir/appli, qualité & personnalisation supérieures au QSR, places assises optionnelles',
    },
    [RestaurantTypes.QuickServiceTakeaway]: {
      title: 'Restauration rapide (QSR) / Vente à emporter',
      description: 'Service au comptoir axé sur la rapidité ; principalement à emporter',
    },
    [RestaurantTypes.CafeAndBakery]: {
      title: 'Café & Boulangerie',
      description: 'Café, viennoiseries, petits plats, petit-déjeuner/brunch',
    },
    [RestaurantTypes.DessertAndIceCream]: {
      title: 'Desserts & Glaces',
      description: 'Concepts axés sur le sucré',
    },
    [RestaurantTypes.DrinksAndBar]: {
      title: 'Boissons & Bar',
      description:
        "Établissements axés sur les boissons ; restauration optionnelle ; livraison d'alcool soumise aux règles locales",
    },
    [RestaurantTypes.DeliveryOnlyOrGhostKitchen]: {
      title: 'Livraison uniquement / Cuisine fantôme',
      description: 'Sans vitrine ; marques virtuelles et cuisines partagées',
    },
  },
  cuisine_types: {
    [CuisineTypes.Pizza]: 'Pizza',
    [CuisineTypes.Burgers]: 'Burgers',
    [CuisineTypes.ChickenFried]: 'Poulet frit',
    [CuisineTypes.Wings]: 'Ailes de poulet',
    [CuisineTypes.KebabDoner]: 'Kebab/Döner',
    [CuisineTypes.Sandwiches]: 'Sandwichs',
    [CuisineTypes.Wraps]: 'Wraps',
    [CuisineTypes.Salads]: 'Salades',
    [CuisineTypes.Healthy]: 'Healthy',
    [CuisineTypes.Bowls]: 'Bowls',
    [CuisineTypes.Vegan]: 'Vegan',
    [CuisineTypes.Vegetarian]: 'Végétarien',
    [CuisineTypes.GlutenFree]: 'Sans gluten',
    [CuisineTypes.Halal]: 'Halal',

    [CuisineTypes.Sushi]: 'Sushi',
    [CuisineTypes.Japanese]: 'Japonais',
    [CuisineTypes.Ramen]: 'Ramen',
    [CuisineTypes.UdonSoba]: 'Udon/Soba',
    [CuisineTypes.Korean]: 'Coréen',
    [CuisineTypes.KoreanFriedChicken]: 'Poulet frit coréen',
    [CuisineTypes.Chinese]: 'Chinois',
    [CuisineTypes.Sichuan]: 'Sichuan',
    [CuisineTypes.CantoneseDimSum]: 'Cantonais/Dim Sum',
    [CuisineTypes.Thai]: 'Thaï',
    [CuisineTypes.Vietnamese]: 'Vietnamien',
    [CuisineTypes.Malaysian]: 'Malaisien',
    [CuisineTypes.Indonesian]: 'Indonésien',
    [CuisineTypes.Filipino]: 'Philippin',
    [CuisineTypes.Poke]: 'Poké',
    [CuisineTypes.HotPot]: 'Hot Pot',
    [CuisineTypes.DumplingsGyozaBao]: 'Dumplings/Gyoza/Bao',

    [CuisineTypes.Indian]: 'Indien',
    [CuisineTypes.Biryani]: 'Biryani',
    [CuisineTypes.Pakistani]: 'Pakistanais',
    [CuisineTypes.SriLankan]: 'Sri-Lankais',
    [CuisineTypes.Nepalese]: 'Népalais',

    [CuisineTypes.Turkish]: 'Turc',
    [CuisineTypes.Lebanese]: 'Libanais',
    [CuisineTypes.Syrian]: 'Syrien',
    [CuisineTypes.Israeli]: 'Israélien',
    [CuisineTypes.Egyptian]: 'Égyptien',
    [CuisineTypes.PersianIranian]: 'Persan/Iranien',
    [CuisineTypes.Iraqi]: 'Irakien',
    [CuisineTypes.Afghan]: 'Afghan',
    [CuisineTypes.ShawarmaFalafel]: 'Shawarma/Falafel',
    [CuisineTypes.MezzeGrill]: 'Mezze/Grill',
    [CuisineTypes.Greek]: 'Grec',
    [CuisineTypes.Mediterranean]: 'Méditerranéen',

    [CuisineTypes.Italian]: 'Italien',
    [CuisineTypes.Pasta]: 'Pâtes',
    [CuisineTypes.French]: 'Français',
    [CuisineTypes.SpanishTapas]: 'Espagnol/Tapas',
    [CuisineTypes.Portuguese]: 'Portugais',
    [CuisineTypes.German]: 'Allemand',
    [CuisineTypes.Austrian]: 'Autrichien',
    [CuisineTypes.Balkan]: 'Balkanique',
    [CuisineTypes.Hungarian]: 'Hongrois',
    [CuisineTypes.Polish]: 'Polonais',
    [CuisineTypes.Czech]: 'Tchèque',
    [CuisineTypes.Georgian]: 'Géorgien',

    [CuisineTypes.Mexican]: 'Mexicain',
    [CuisineTypes.TexMex]: 'Tex-Mex',
    [CuisineTypes.Peruvian]: 'Péruvien',
    [CuisineTypes.Brazilian]: 'Brésilien',
    [CuisineTypes.Argentinian]: 'Argentin',
    [CuisineTypes.Caribbean]: 'Caribéen',
    [CuisineTypes.BBQAmerican]: 'BBQ/Américain',
    [CuisineTypes.Steakhouse]: 'Steakhouse',
    [CuisineTypes.AmericanGeneral]: 'Américain (général)',
    [CuisineTypes.HotDogs]: 'Hot Dogs',

    [CuisineTypes.Seafood]: 'Fruits de mer',
    [CuisineTypes.FishAndChips]: 'Fish and Chips',
    [CuisineTypes.SteamedFish]: 'Poisson vapeur',

    [CuisineTypes.BreakfastBrunch]: 'Petit-déjeuner/Brunch',
    [CuisineTypes.Bagels]: 'Bagels',
    [CuisineTypes.Bakery]: 'Boulangerie',
    [CuisineTypes.PastryDessert]: 'Pâtisserie/Dessert',
    [CuisineTypes.WafflesCrepes]: 'Gaufres/Crêpes',
    [CuisineTypes.IceCreamGelato]: 'Glaces/Gelato',
    [CuisineTypes.Donuts]: 'Donuts',
    [CuisineTypes.Cakes]: 'Gâteaux',

    [CuisineTypes.CoffeeCafe]: 'Café',
    [CuisineTypes.BubbleTea]: 'Bubble Tea',
    [CuisineTypes.JuiceSmoothies]: 'Jus/Smoothies',
    [CuisineTypes.Milkshakes]: 'Milkshakes',
    [CuisineTypes.BarPub]: 'Bar/Pub',
    [CuisineTypes.WineBar]: 'Bar à vins',
    [CuisineTypes.Cocktails]: 'Cocktails',

    [CuisineTypes.TapasMezeSmallPlates]: 'Tapas/Mezze/Petites assiettes',
    [CuisineTypes.Noodles]: 'Nouilles',
    [CuisineTypes.Soup]: 'Soupe',
    [CuisineTypes.Schnitzel]: 'Schnitzel',
    [CuisineTypes.SoulFood]: 'Soul Food',
    [CuisineTypes.ComfortFood]: 'Comfort Food',
    [CuisineTypes.StreetFood]: 'Street Food',
    [CuisineTypes.OrganicBio]: 'Bio/Organique',
    [CuisineTypes.KidsMenu]: 'Menu enfants',
  },
  cuisine_categories: {
    [CuisineCategories.TopGeneral]: 'Top/Général',
    [CuisineCategories.AsianPacific]: 'Asiatique/Pacifique',
    [CuisineCategories.SouthAsian]: 'Asie du Sud',
    [CuisineCategories.MiddleEastMediterranean]: 'Moyen-Orient/Méditerranée',
    [CuisineCategories.Europe]: 'Europe',
    [CuisineCategories.Americas]: 'Amériques',
    [CuisineCategories.SeafoodSpecialty]: 'Spécialités de la mer',
    [CuisineCategories.BreakfastBakerySweets]: 'Petit-déj./Boulangerie & Sucreries',
    [CuisineCategories.BeverageLed]: 'Axé boissons',
    [CuisineCategories.OtherConcepts]: 'Autres concepts',
  },
};
